import { render } from "./PersonalDetailsPage.vue?vue&type=template&id=702c2bc2&scoped=true"
import script from "./PersonalDetailsPage.vue?vue&type=script&lang=js"
export * from "./PersonalDetailsPage.vue?vue&type=script&lang=js"

import "./PersonalDetailsPage.vue?vue&type=style&index=0&id=702c2bc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702c2bc2"]])

export default __exports__